import { useQuery } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import { contractApi } from '@/api/contract'
import CustomerInfoSection from '@/components/contract/CustomerInfoSection'
import ContractContactSection from '@/components/contract/ContractContactSection'
import ContractInfoSection from '@/components/contract/ContractInfoSection'
import ContractNotice from '@/components/contract/ContractNotice'

export default function ContractManagement() {
  const { t } = useTranslation('admin')
  const { data, isLoading } = useQuery({
    queryKey: ['contract'],
    queryFn: () => contractApi.getContractPage(),
  })

  const contract = data?.data?.data

  if (isLoading) {
    return (
      <div className="flex justify-center items-center py-20">
        <div className="inline-block w-8 h-8 rounded-full border-b-2 animate-spin border-primary-600" />
      </div>
    )
  }

  if (!contract) {
    return (
      <div className="text-center py-20 text-gray-400">
        {t('contract.noData')}
      </div>
    )
  }

  const formatDate = (dateStr: string) => {
    try {
      return new Date(dateStr).toLocaleDateString('ko-KR', { year: 'numeric', month: '2-digit', day: '2-digit' })
    } catch {
      return dateStr
    }
  }

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-gray-900">{t('contract.title')}</h1>
        <p className="mt-1 text-sm text-gray-500">{t('contract.description')}</p>
      </div>

      {/* 고객 정보 */}
      <div className="space-y-4">
        <h2 className="text-lg font-semibold text-gray-900">{t('contract.customerInfo')}</h2>
        <CustomerInfoSection data={contract} />
        <ContractContactSection data={contract} />

        {/* 등록일 / 수정일 */}
        <div className="flex gap-6 text-sm text-gray-500 px-1">
          <span>{t('contract.createdAt')}: {formatDate(contract.createdAt)}</span>
          <span>{t('contract.updatedAt')}: {formatDate(contract.updatedAt)}</span>
        </div>
      </div>

      {/* 계약 정보 */}
      <div className="space-y-4">
        <h2 className="text-lg font-semibold text-gray-900">{t('contract.contractInfo')}</h2>
        <ContractInfoSection data={contract} />
      </div>

      {/* 안내 메시지 */}
      <ContractNotice />
    </div>
  )
}
